import { render, staticRenderFns } from "./DonutChart57.vue?vue&type=template&id=38aa4958&scoped=true"
import script from "./DonutChart57.vue?vue&type=script&lang=js"
export * from "./DonutChart57.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa4958",
  null
  
)

export default component.exports